<template>
  <b-carousel>
    <b-carousel-item v-for="(carousel, i) in carousels" :key="i">
      <figure class="image is-16by9">
        <img class="preview-image" :src="carousel.image">
      </figure>
    </b-carousel-item>
  </b-carousel>
</template>

<style>
.carousel-items {
  border-radius: 10px;
}
</style>

<script>
import Preview1 from '@/assets/preview-images/1.png'
import Preview2 from '@/assets/preview-images/2.png'
import Preview3 from '@/assets/preview-images/3.png'
import Preview4 from '@/assets/preview-images/4.png'
import Preview5 from '@/assets/preview-images/5.png'

export default {
  data(){
    return {
      carousels: [
        { text: 'Preview 1', image: Preview1 }, 
        { text: 'Preview 2', image: Preview2 }, 
        { text: 'Preview 3', image: Preview3 }, 
        { text: 'Preview 4', image: Preview4 }, 
        { text: 'Preview 5', image: Preview5 }, 
      ]
    }
  }
}
</script>